import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import RequestApi from '../../Miscelania/RequestApi';

import ScheduleGradeAircraftLine from './ScheduleGradeAircraftLine';
import ScheduleGradeAircraftLineAlternate from './ScheduleGradeAircraftLineAlternate';

class ScheduleGradeEditTab extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      total_days: 0,
      zoom_level: 4,
      edit_mode: false,
      selected_date: false,
      grade: [],
      grade_alternate: [],
      grade_extra_main: [],
      staffs_list: [],
      width_table: '100%',
      width_table_tbody: '100%',
      bases_active_list: [],
      aircrafts_list: [],
      remaining_staffs_list: [],
      schedule_used_regime_list: [],
      staffs_by_id: {},
      alternate_titles: {
        'EXTRA': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.TripulacaoExtra,
        'INS': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.Instrucao,
        'EQUIP': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.ChefeDeEquipamento,
        'MEDICA': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.DispensaMedica,
        'MANUT': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.Manutencao,
        'FERIAS': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.Ferias,
        'FORA': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.ForaDeEscala,
        'RESERVA': this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.titulosAlternativos.Reserva,
      },
      total_colors: {
        'white': {backgroundColor: '#fff', color: '#333', fontWeight: 'bold'},
        'more_cms': {backgroundColor: '#F5ADD4', color: '#333', fontWeight: 'bold'},
        'more_copil': {backgroundColor: '#CECECE', color: '#333', fontWeight: 'bold'},
        'more_cmdt': {backgroundColor: '#79CA86', color: '#333', fontWeight: 'bold'},
        'less_cms': {backgroundColor: '#817BDB', color: '#333', fontWeight: 'bold'},
        'less_copil': {backgroundColor: '#DE8B4E', color: '#333', fontWeight: 'bold'},
        'less_cmdt': {backgroundColor: '#E87C7C', color: '#333', fontWeight: 'bold'},
      }
    };

    this.changeTableStyle = this.changeTableStyle.bind(this);
    this.changeZoom = this.changeZoom.bind(this);
    this.addLine = this.addLine.bind(this);
    this.deleteAircraft = this.deleteAircraft.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.deleteLineAlternate = this.deleteLineAlternate.bind(this);
    this.changeBaseId = this.changeBaseId.bind(this);
    this.changeAircraftSingle = this.changeAircraftSingle.bind(this);
    this.changeGroup = this.changeGroup.bind(this);
    this.changePeriodUpdate = this.changePeriodUpdate.bind(this);
    this.changeStaffIdToNT = this.changeStaffIdToNT.bind(this);
    this.changeStaffId = this.changeStaffId.bind(this);
    this.changePeriodSimple = this.changePeriodSimple.bind(this);
    this.cancelChangePeriod = this.cancelChangePeriod.bind(this);
    this.addStaffWithPeriod = this.addStaffWithPeriod.bind(this);
    this.changeDateType = this.changeDateType.bind(this);
    this.changeDateTypeAlternate = this.changeDateTypeAlternate.bind(this);
    this.cloneDay = this.cloneDay.bind(this);
    this.cloneDayAlternate = this.cloneDayAlternate.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.grade) && Array.isArray(newProps.schedule_used_regime_list) && Array.isArray(newProps.staffs_list)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      var total_days = 0;
      Object.keys(this.props.schedule_days).map(function(k) {
        total_days = total_days + 1;
      })
      this.setState({
        grade: newProps.grade,
        schedule_used_regime_list: newProps.schedule_used_regime_list,
        schedule_used_regimes: newProps.schedule_used_regimes,
        grade_alternate: newProps.grade_alternate,
        grade_extra_main: newProps.grade_extra_main,
        staffs_list: newProps.staffs_list,
        aircrafts_list: newProps.aircrafts_list,
        bases_active_list: newProps.bases_active_list,
        remaining_staffs_list: newProps.remaining_staffs_list,
        staffs_by_id: newProps.staffs_by_id,
        total_days: total_days,
        loaded: 1,
      });
      this.changeTableStyle(total_days, this.state.zoom_level);

    }
    this.setState({edit_mode: newProps.edit_mode});
  }

  changeTableStyle (total_days, zoom_level) {
    var total_width_days = 0;
    var width_table = 0;
    var width_table_tbody = 0;

    switch(zoom_level) {
      case 1:
        total_width_days = (41 * total_days);
        width_table = 63 + 51 + 30 + 51 + 36 + 89 + 38 + 33 + total_width_days;
        width_table_tbody = width_table;
        break;
      case 2:
        total_width_days = (45 * total_days);
        width_table = 67 + 56 + 33 + 57 + 40 + 98 + 41 + 36 + total_width_days;
        width_table_tbody = width_table + 0;
        break;
      case 3:
        total_width_days = (49 * total_days);
        width_table = 72 + 62 + 36 + 63 + 44 + 108 + 45 + 39 + total_width_days;
        width_table_tbody = width_table + 0;
        break;
      default:
        total_width_days = (54 * total_days);
        width_table = 80 + 68 + 40 + 70 + 49 + 120 + 50 + 47 + total_width_days;
        width_table_tbody = width_table + 0;
    }

    width_table = width_table + 'px';
    width_table_tbody = width_table_tbody + 'px';

    this.setState({width_table: width_table});
    this.setState({width_table_tbody: width_table_tbody});
  }

  changeZoom (number) {
    var zoom_level = this.state.zoom_level;
    zoom_level += number;
    zoom_level = (zoom_level < 1) ? 1 : (zoom_level > 4) ? 4 : zoom_level;
    this.setState({zoom_level: zoom_level});
    this.changeTableStyle(this.state.total_days, zoom_level)
  }

  // FUNÇÕES DE EDIÇÃO DE ESCALA

  deleteAircraft(schedule_grade_aircraft_id) {
    var self = this;
    if(self.state.edit_mode) {
      var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.removerAeronaveETodosSeusTripulantes);
      if (confirm) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = [];
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sga_id !== schedule_grade_aircraft_id) {
            grade_prov.push({...grade.grade[k]});
          }
        })
        grade.grade = [...grade_prov];
        self.props.updateDataEditMode(grade);
      }
    }
  }
  
  addLine(schedule_grade_aircraft_id) {
    var self = this;
    if(self.state.edit_mode) {
      var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.adicionarLinhaNestaAeronave);
      if (confirm) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = [...self.state.grade];
        var found = false;
        var new_line = {};
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sga_id === schedule_grade_aircraft_id && !found) {
            var new_id = Math.floor(Math.random() * 1000000000) + 100000000;
            var new_sgas_id = Math.floor(Math.random() * 1000000000) + 100000000;
            new_line = {
              aircraft: grade_prov[k].aircraft,
              aircraft_id: grade_prov[k].aircraft_id,
              contract_id: grade_prov[k].contract_id,
              base: grade_prov[k].base,
              base_id: grade_prov[k].base_id,
              color: grade_prov[k].color,
              days: [],
              double: 0,
              role: 'INDISP',
              id: new_id,
              line: grade_prov[k].line,
              schedule_grade_id: grade_prov[k].schedule_grade_id,
              schedule_id: grade_prov[k].schedule_id,
              priority: 0,
              sga_id: new_id,
              sgas_id: new_sgas_id,
              new: true,
              double_bool: null,
              designation_id: null,
              inscription: null,
              schedule_regime_id: grade_prov[k].schedule_regime_id,
              schedule_used_regime_id: grade_prov[k].schedule_used_regime_id,
              role_alternate: null,
              type: null,
              staff: null,
              staff_id: null
            }
            grade_prov.splice(k, 0, {...new_line});
            found = true;
          }
        })
        grade.grade = [...grade_prov];
        self.props.updateDataEditMode(grade);
        self.props.handleAlert('', '', 'open');
        setTimeout(function(){ 
          self.props.updateDataEditMode(grade);
          self.props.handleAlert('', '', 'closed');
        }, 300);
      }
    }
  }

  deleteLine(schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.removerLinhaDestaAeronave);
      if (confirm) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = [...self.state.grade];
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
            grade_prov.splice(k, 1);
          }
        })
        grade.grade = [...grade_prov];
        self.props.updateDataEditMode(grade);
      }
    }
  }

  deleteLineAlternate(schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.removerTripulante);
      if (confirm) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = {...self.state.grade_alternate};
    
        Object.keys(grade.grade_alternate).map(function(TITLE) {
          if(grade.grade_alternate[TITLE] !== null && typeof grade.grade_alternate[TITLE] !== 'undefined' && typeof self.state.alternate_titles[TITLE] !== 'undefined') {
            Object.keys(grade.grade_alternate[TITLE]).map(function(k) {
              if(typeof grade.grade_alternate[TITLE][k] !== 'undefined') {
                if(grade.grade_alternate[TITLE][k].sgas_id === schedule_grade_aircraft_staff_id) {
                  grade_prov[TITLE].splice(k, 1);
                }
              }
            })
          }
        })
    
        grade.grade_alternate = {...grade_prov};
        self.props.updateDataEditMode(grade);
      }
    }  
  }

  changeBaseId (base_id, schedule_grade_aircraft_id) {
    var self = this;
    if(self.state.edit_mode) {
      var base_name = '';
      Object.keys(self.props.bases_active_list).map(function(bl) {
        if(self.props.bases_active_list[bl].value === base_id) {
          base_name = self.props.bases_active_list[bl].label;
        }
      })
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];
      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sga_id === schedule_grade_aircraft_id) {
          grade_prov[k].base_id = base_id;
          grade_prov[k].base = base_name;
        }
      })
      grade.grade = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }

  changeGroup (line, schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];

      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
          grade_prov[k].line = line;
        }
      })

      grade.grade = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }

  changePeriodUpdate (responseJson, schedule_grade_aircraft_staff_id, schedule_used_regime_id) {
    var self = this;
    if(self.state.edit_mode) {
      var found = false;
      Object.keys(self.props.schedule_used_regimes).map(function(k) {
        var sur = self.props.schedule_used_regimes[k];
        if (sur.id == schedule_used_regime_id) {
          found = true
        }
      })

      if (found) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = [...self.state.grade];
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
            grade_prov[k].schedule_used_regime_id = schedule_used_regime_id;
            grade_prov[k].schedule_regime_id = responseJson.data.schedule_regime_id;
            grade_prov[k].days = responseJson.data.days;
          }
        })
  
        grade.grade = [...grade_prov];
        self.props.updateDataEditMode(grade);
      } else {
        this.props.handleAlert(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.numeroDeRegimeNaoCadastrado, 'error', 'open');
      }
    }
  }

  changePeriodSimple (schedule_grade_aircraft_staff_id, schedule_used_regime_id) {

    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];
      var found = false;
      var schedule_regime_id = false;
      Object.keys(self.props.schedule_used_regimes).map(function(k) {
        var sur = self.props.schedule_used_regimes[k];
        if (sur.id == schedule_used_regime_id) {
          found = true;
          schedule_regime_id = sur.schedule_regime_id;
        }
      })

      if (found) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = [...self.state.grade];
  
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
            grade_prov[k].schedule_used_regime_id = schedule_used_regime_id;
            grade_prov[k].schedule_regime_id = schedule_regime_id;
          }
        })
  
        grade.grade = [...grade_prov];
        self.props.updateDataEditMode(grade);
      } else {
        this.props.handleAlert(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.numeroDeRegimeNaoCadastrado, 'error', 'open');
      }
    }
  }

  cancelChangePeriod () {
    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      self.props.updateDataEditMode(grade);
    }
  }

  changeStaffIdToNT (schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.retirarTripulacaoDestaLinhaNestaAeronave);
      if (confirm) {
        var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
        var grade_prov = [...self.state.grade];
        var new_line = {};
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
            new_line = {
              aircraft: grade_prov[k].aircraft,
              aircraft_id: grade_prov[k].aircraft_id,
              base: grade_prov[k].base,
              base_id: grade_prov[k].base_id,
              color: grade_prov[k].color,
              days: [],
              double: 0,
              role: '',
              id: grade_prov[k].id,
              sgas_id: grade_prov[k].sgas_id,
              sga_id: grade_prov[k].sga_id,
              line: grade_prov[k].line,
              priority: 0,
              new: true,
              double_bool: null,
              designation_id: null,
              inscription: null,
              period: grade_prov[k].period,
              role_alternate: null,
              type: null,
              staff: null,
              staff_id: null
            }
            grade_prov[k] = new_line;
          }
        })
        grade.grade = [...grade_prov];
        self.props.updateDataEditMode(grade);
      }
    }
  }

  changeAircraftSingle (aircraft_id, schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];
      var aircraft = '';
      var contract_id = 0;
      var sga_id = 0;
      var color = 0;
      var base_id = 0;
      var base = 0;

      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].aircraft_id === aircraft_id) {
          aircraft = grade.grade[k].aircraft;
          sga_id = grade.grade[k].sga_id;
          color = grade.grade[k].color;
          base_id = grade.grade[k].base_id;
          contract_id = grade.grade[k].contract_id;
          base = grade.grade[k].base;
        }
      })

      var new_line = {};
      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
          new_line = {...grade.grade[k]};
          new_line.aircraft = aircraft;
          new_line.sga_id = sga_id;
          new_line.aircraft_id = aircraft_id;
          new_line.color = color;
          new_line.base_id = base_id;
          new_line.contract_id = contract_id;
          new_line.base = base;
          grade_prov[k] = new_line;
        }
      })
      grade.grade = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }

  changeStaffId (schedule_grade_aircraft_staff_id, staff_id) {
    var self = this;
    if(self.state.edit_mode) {

      this.props.handleAlert('', '', 'open');
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];

      // Antes, verificamos se esse staff_id já está escalado
      var found = false;
      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sgas_id !== schedule_grade_aircraft_staff_id && grade.grade[k].staff_id === staff_id) {
          found = true;
        }
      })

      if(!found) {
        Object.keys(grade.grade_alternate).map(function(TITLE) {
          if(grade.grade_alternate[TITLE] !== null && typeof grade.grade_alternate[TITLE] !== 'undefined' && typeof self.state.alternate_titles[TITLE] !== 'undefined') {
            Object.keys(grade.grade_alternate[TITLE]).map(function(k) {
              if(typeof grade.grade_alternate[TITLE][k] !== 'undefined') {
                if(grade.grade_alternate[TITLE][k].sgas_id !== schedule_grade_aircraft_staff_id && parseInt(grade.grade_alternate[TITLE][k].staff_id) === staff_id) {
                  found = true;
                }
              }
            })
          }
        })
      }


      if(found) {
        this.props.handleAlert(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.esteTripulanteJaEstaEscalado, 'error', 'open');
      } else {
        var datasave = {
          id: schedule_grade_aircraft_staff_id,
          staff_id: staff_id,
        };
    
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/escala/grade/aeronave/linha/tripulante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.refs.request_api.validate(responseJson, 'alert');
              Object.keys(grade.grade).map(function(k) {
                if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
                  grade_prov[k].staff_id = staff_id;
                  grade_prov[k].staff = self.state.staffs_by_id[staff_id];
                  grade_prov[k].role = responseJson.data.designation.initials;
                  grade_prov[k].days = responseJson.data.days;
                  grade_prov[k].inscription = responseJson.data.inscription;
                  grade_prov[k].priority = responseJson.data.designation.priority;
                  grade_prov[k].designation_id = responseJson.data.designation.designation_id;
                  grade_prov[k].type = responseJson.data.designation.type;
                }
              })
              grade.grade = [...grade_prov];
              self.props.updateDataEditMode(grade);
            } else {
              self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }
  }

  addStaffWithPeriod (schedule_used_regime_id, start_day, schedule_grade_aircraft_staff_id, staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      self.props.handleAlert('', '', 'open');
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];
      // Antes, verificamos se esse staff_id já está escalado
      var found = false;
      
      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sgas_id !== schedule_grade_aircraft_staff_id && grade.grade[k].staff_id === staff_id) {
          found = true;
        }
      })

      if(!found) {
        Object.keys(grade.grade_alternate).map(function(TITLE) {
          if(grade.grade_alternate[TITLE] !== null && typeof grade.grade_alternate[TITLE] !== 'undefined' && typeof self.state.alternate_titles[TITLE] !== 'undefined') {
            Object.keys(grade.grade_alternate[TITLE]).map(function(k) {
              if(typeof grade.grade_alternate[TITLE][k] !== 'undefined') {
                if(grade.grade_alternate[TITLE][k].sgas_id !== schedule_grade_aircraft_staff_id && grade.grade_alternate[TITLE][k].staff_id == staff_id) {
                  found = true;
                }
              }
            })
          }
        })
      }

      if(found) {
        this.props.handleAlert(this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.esteTripulanteJaEstaEscalado, 'error', 'open');
      } else {
        Object.keys(grade.grade).map(function(k) {
          if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
            var header = self.refs.request_api.header('application/json');
            var datasave = {
              id: schedule_grade_aircraft_staff_id,
              staff_id: staff_id,
              schedule_used_regime_id: schedule_used_regime_id,
              start_day: start_day,
              schedule_grade_aircraft_id: grade_prov[k].sga_id,
              schedule_grade_id: grade_prov[k].schedule_grade_id,
              schedule_id: grade_prov[k].schedule_id,
              base_id: grade_prov[k].base_id,
            };
            Promise.resolve(header).then(function(value) {
              fetch(config.get('api') + '/escala/grade/aeronave/adicionar/linha', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
                self.refs.request_api.validate(responseJson, 'alert');
                if (responseJson.status === 'success') {
                  grade_prov[k].staff_id = staff_id;
                  grade_prov[k].schedule_used_regime_id = responseJson.data.schedule_used_regime_id;
                  grade_prov[k].schedule_regime_id = responseJson.data.schedule_regime_id;
                  grade_prov[k].staff = self.state.staffs_by_id[staff_id];
                  grade_prov[k].role = responseJson.data.designation.initials;
                  grade_prov[k].days = responseJson.data.days;
                  grade_prov[k].inscription = responseJson.data.inscription;
                  grade_prov[k].priority = responseJson.data.designation.priority;
                  grade_prov[k].designation_id = responseJson.data.designation.designation_id;
                  grade_prov[k].type = responseJson.data.designation.type;
                } else {
                  self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
                }
                grade.grade = [...grade_prov];
                self.props.updateDataEditMode(grade);
              }).catch((error) => {
                console.error(error);
              });
            });
          }
        })
      }
        
    }
  }

  changeDateType (schedule_grade_aircraft_staff_id, date, type) {
    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];

      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
          grade_prov[k].days[date].type = type;
        }
      })

      grade.grade = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }

  changeDateTypeAlternate (schedule_grade_aircraft_staff_id, date, type) {
    var self = this;
    if(self.state.edit_mode) {
      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = {...self.state.grade_alternate};

      Object.keys(grade.grade_alternate).map(function(TITLE) {
        if(grade.grade_alternate[TITLE] !== null && typeof grade.grade_alternate[TITLE] !== 'undefined' && typeof self.state.alternate_titles[TITLE] !== 'undefined') {
          Object.keys(grade.grade_alternate[TITLE]).map(function(k) {
            if(grade.grade_alternate[TITLE][k].sgas_id === schedule_grade_aircraft_staff_id) {
              grade_prov[TITLE][k].days[date].type = type;
            }
          })
        }
      })

      grade.grade_alternate = {...grade_prov};
      self.props.updateDataEditMode(grade);
    }
  }

  cloneDayAlternate (direction, type, date, schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var iso_date = date.split('/');
      iso_date = iso_date[2] + '-' + iso_date[1] + '-' + iso_date[0] + 'T15:00:00';

      var modifier = 1;
      if(direction === 'left') {
        modifier = -1;
      }

      var next_date = new Date(iso_date);
      var next_date_string  = date;
      var next_date_iso = iso_date;
      var current_day = 0;
      var day = '';
      var month = '';
      var year = '';

      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = {...self.state.grade_alternate};
      Object.keys(grade.grade_alternate).map(function(TITLE) {
        if(grade.grade_alternate[TITLE] !== null && typeof grade.grade_alternate[TITLE] !== 'undefined' && typeof self.state.alternate_titles[TITLE] !== 'undefined') {
          Object.keys(grade.grade_alternate[TITLE]).map(function(k) {
            if(typeof grade.grade_alternate[TITLE][k] !== 'undefined') {
              if(grade.grade_alternate[TITLE][k].sgas_id === schedule_grade_aircraft_staff_id) {
                if(typeof grade_prov[TITLE][k].days[next_date_string] !== 'undefined') {
                  var found = false
                  while(!found && typeof grade_prov[TITLE][k].days[next_date_string] !== 'undefined') {
                    if(grade_prov[TITLE][k].days[next_date_string].type === grade_prov[TITLE][k].days[date].type) {
                      current_day = next_date.getDate();
                      next_date = new Date(next_date_iso);
                      next_date.setDate(current_day+modifier);
                      
                      next_date_string  = next_date.toLocaleDateString('en-US');
                      next_date_string = next_date_string.split('/');
                      day = (next_date_string[1].length == 1) ? '0'+next_date_string[1] : next_date_string[1];
                      month = (next_date_string[0].length == 1) ? '0'+next_date_string[0] : next_date_string[0];
                      year = next_date_string[2];
                      
                      next_date_string = day+'/'+month+'/'+year;
                      next_date_iso = year+'-'+month+'-'+day + 'T15:00:00';
                    } else {
                      found = true;
                      grade_prov[TITLE][k].days[next_date_string].type = type;
                    }
                  }
                }
              }
            }
          })
        }
      })

      grade.grade_alternate = {...grade_prov};
      self.props.updateDataEditMode(grade);
    }
  }

  cloneDay (direction, type, date, schedule_grade_aircraft_staff_id) {
    var self = this;
    if(self.state.edit_mode) {
      var iso_date = date.split('/');
      iso_date = iso_date[2] + '-' + iso_date[1] + '-' + iso_date[0] + 'T15:00:00';

      var modifier = 1;
      if(direction === 'left') {
        modifier = -1;
      }

      var next_date = new Date(iso_date);
      var next_date_string  = date;
      var next_date_iso = iso_date;
      var current_day = 0;
      var day = '';
      var month = '';
      var year = '';

      var grade = {grade: [...self.state.grade], grade_alternate: {...self.state.grade_alternate}};
      var grade_prov = [...self.state.grade];
      Object.keys(grade.grade).map(function(k) {
        if(grade.grade[k].sgas_id === schedule_grade_aircraft_staff_id) {
          if(typeof grade_prov[k].days[next_date_string] !== 'undefined') {
            var found = false;

            while(!found && typeof grade_prov[k].days[next_date_string] !== 'undefined') {
              if(grade_prov[k].days[next_date_string].type === grade_prov[k].days[date].type) {
                current_day = next_date.getDate();
                next_date = new Date(next_date_iso);
                next_date.setDate(current_day+modifier);
                
                next_date_string  = next_date.toLocaleDateString('en-US');
                next_date_string = next_date_string.split('/');
                day = (next_date_string[1].length == 1) ? '0'+next_date_string[1] : next_date_string[1];
                month = (next_date_string[0].length == 1) ? '0'+next_date_string[0] : next_date_string[0];
                year = next_date_string[2];
                
                next_date_string = day+'/'+month+'/'+year;
                next_date_iso = year+'-'+month+'-'+day + 'T15:00:00';
              } else {
                found = true;
                grade_prov[k].days[next_date_string].type = type;
              }
            }
          }
        }
      })

      grade.grade = [...grade_prov];
      self.props.updateDataEditMode(grade);
    }
  }
  
  render() {
    var self = this;

    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tituloEscala}</h3>
  <div className="pull-right">
    <button className="btn button-inline btn-default" onClick={() => self.changeZoom(1)}><i className="fa fa-search-plus"></i></button>
    <button className="btn button-inline btn-default" onClick={() => self.changeZoom(-1)}><i className="fa fa-search-minus"></i></button>
    {!self.state.edit_mode && <button className="btn button-inline btn-primary" onClick={() => self.props.toggleEditMode()}><i className="fa fa-pencil"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.botaoAbrirEdicao}</button>}
    {self.state.edit_mode && <button className="btn button-inline btn-success" onClick={() => self.props.saveGrade()}><i className="fa fa-save"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.botaoSalvarEdicao}</button>}
    {self.state.edit_mode && <button className="btn button-inline btn-danger" onClick={() => self.props.resetGrade()}><i className="fa fa-trash"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.botaoDescartarMudancas}</button>}
  </div>
  <div className="clearfix"></div>
  <hr />
  {(this.state.grade === null || typeof this.state.grade === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.nenhumaAeronaveEscalada}</em></small><hr/></div>
  :
  <div className="table-schedule-grade-container">
    <div className="table-schedule-wrapper table-schedule-wrapper-main">
      <table className="table table-schedule table-schedule-main" style={{width: self.state.width_table}}>
        <tbody style={{width: self.state.width_table_tbody}}>
          <tr>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-base-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Base}</td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-act-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Aeronave}</td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-del-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-period-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Regime}</td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-group-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Grupo}</td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-name-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Nome}</td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-inscription-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Matricula}</td>
            <td className={"text-center table-schedule-sticky-header table-schedule-main-designation-" + self.state.zoom_level}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.Designacao}</td>
            {Object.keys(self.props.schedule_days).map(function(k) {
              var day = self.props.schedule_days[k];
              return(
                <td className={"text-center table-schedule-sticky-header-day table-schedule-main-day-" + self.state.zoom_level}>{day.weekday}</td>
              );
            })}
          </tr>
          <tr>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-base-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-act-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-del-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-period-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-group-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-name-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-inscription-" + self.state.zoom_level}></td>
            <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header table-schedule-main-designation-" + self.state.zoom_level}></td>
            {Object.keys(self.props.schedule_days).map(function(k) {
              var day = self.props.schedule_days[k];
              return(
                <td className={"text-center table-schedule-sticky-header-second-row table-schedule-sticky-header-day table-schedule-main-day-" + self.state.zoom_level}>{day.day_simple}</td>
              );
            })}
          </tr>
          {Object.keys(self.state.grade).map(function(k) {
            var sgas = self.state.grade[k];
            return(
              <ScheduleGradeAircraftLine
                schedule_id={self.props.schedule_id}
                bases_list={self.props.bases_list}
                schedule_grade_id={self.props.schedule_grade_id}
                updateData={self.props.updateData}
                updated={self.props.updated}
                handleAlert={self.props.handleAlert}
                types_list={self.props.schedule_grade_initials_secondary}
                sgas={sgas}
                staffs_list={self.props.staffs_list}
                bases_active_list={self.props.bases_active_list}
                aircrafts_list={self.props.aircrafts_list}
                schedule_used_regime_list={self.props.schedule_used_regime_list}
                schedule_used_regimes={self.props.schedule_used_regimes}
                remaining_staffs_list={self.props.remaining_staffs_list}
                schedule_days={self.props.schedule_days}
                initials_colors={self.props.initials_colors}
                toggleEditMode={self.props.toggleEditMode}
                edit_mode={self.state.edit_mode}
                zoom_level={self.state.zoom_level}
                generatePersonalAlerts={self.props.generatePersonalAlerts}
                generateAircraftAlerts={self.props.generateAircraftAlerts}
                // Funções de edição
                addLine={self.addLine}
                deleteAircraft={self.deleteAircraft}
                deleteLine={self.deleteLine}
                changeBaseId={self.changeBaseId}
                changeAircraftAll={self.changeAircraftAll}
                changeAircraftSingle={self.changeAircraftSingle}
                changeGroup={self.changeGroup}
                changePeriodUpdate={self.changePeriodUpdate}
                changePeriodSimple={self.changePeriodSimple}
                cancelChangePeriod={self.cancelChangePeriod}
                changeStaffIdToNT={self.changeStaffIdToNT}
                changeStaffId={self.changeStaffId}
                addStaffWithPeriod={self.addStaffWithPeriod}
                changeDateType={self.changeDateType}
                cloneDay={self.cloneDay}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
  }
  {(this.state.grade_alternate === null || typeof this.state.grade_alternate === 'undefined') ?  ''
  :
    <div>
        {Object.keys(this.state.grade_alternate).map(function(TITLE) {
          if(self.state.grade_alternate[TITLE] !== null && typeof self.state.grade_alternate[TITLE] !== 'undefined' && typeof self.state.alternate_titles[TITLE] !== 'undefined') {
            return(
              <div className="table-schedule-grade-container">
                <hr/>
                <h3 className="page-title">{self.state.alternate_titles[TITLE]}</h3>
                <hr/>
                <div className="table-schedule-wrapper">
                  <table className="table table-schedule-alternate table-bordered">
                    <tbody id="suppliers-certifications">
                      <tr>
                        <td className="text-center table-schedule-sticky table-schedule-main-del-alternate"></td>
                        <td className="text-center table-schedule-sticky table-schedule-main-name-alternate">{self.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaAlternativa.Nome}</td>
                        <td className="text-center table-schedule-sticky table-schedule-main-inscription-alternate">{self.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaAlternativa.Matricula}</td>
                        <td className="text-center table-schedule-sticky table-schedule-main-designation-alternate">{self.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaAlternativa.Designacao}</td>
                        {Object.keys(self.props.schedule_days).map(function(k) {
                          var day = self.props.schedule_days[k];
                          return(
                            <td className="table-schedule-main-day-alternate">{day.weekday}</td>
                          );
                        })}
                      </tr>
                      <tr>
                        <td className="text-center table-schedule-sticky table-schedule-main-del-alternate"></td>
                        <td className="text-center table-schedule-sticky table-schedule-main-name-alternate"></td>
                        <td className="text-center table-schedule-sticky table-schedule-main-inscription-alternate"></td>
                        <td className="text-center table-schedule-sticky table-schedule-main-designation-alternate"></td>
                        {Object.keys(self.props.schedule_days).map(function(k) {
                          var day = self.props.schedule_days[k];
                          return(
                            <td className="table-schedule-main-day-alternate">{day.day_simple}</td>
                          );
                        })}
                      </tr>
                      {Object.keys(self.state.grade_alternate[TITLE]).map(function(k) {
                        var sgas = self.state.grade_alternate[TITLE][k];
                        return(
                          <ScheduleGradeAircraftLineAlternate schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id}  updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} types_list={self.props.schedule_grade_initials_secondary} sgas={sgas} staffs_list={self.props.staffs_list} schedule_days={self.props.schedule_days} initials_colors={self.props.initials_colors} toggleEditMode={self.props.toggleEditMode} edit_mode={self.state.edit_mode} generatePersonalAlerts={self.props.generatePersonalAlerts} changeDateType={self.changeDateTypeAlternate} deleteLineAlternate={self.deleteLineAlternate} cloneDay={self.cloneDayAlternate} zoom_level={4} />
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          } else {
            return('');
          }
        })}
        {(self.state.grade_alternate['totals'] !== null && typeof self.state.grade_alternate['totals'] !== 'undefined') ?
            <div className="table-schedule-grade-container">
              <hr/>
              <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tituloTotais}</h3>
              <hr/>
              <table className="table table-schedule-alternate table-bordered">
                  <tbody id="suppliers-certifications">
                    <tr>
                      <td className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.Legenda}</td>
                      <td className="text-center" style={self.state.total_colors['less_cmdt']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.FaltandoComandantes}</td>
                      <td className="text-center" style={self.state.total_colors['more_cmdt']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.SobrandoComandantes}</td>
                      <td className="text-center" style={self.state.total_colors['less_copil']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.FaltandoCopilotos}</td>
                      <td className="text-center" style={self.state.total_colors['more_copil']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.SobrandoCopilotos}</td>
                      <td className="text-center" style={self.state.total_colors['less_cms']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.FaltandoComissarios}</td>
                      <td className="text-center" style={self.state.total_colors['more_cms']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.SobrandoComissarios}</td>
                      <td className="text-center" style={self.state.total_colors['white']}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisTripulacao.QuantidadesCorretas}</td>
                    </tr>
                  </tbody>
                </table>
              <hr/>
              <div className="table-schedule-wrapper">
                <table className="table table-schedule-alternate table-bordered">
                  <tbody id="suppliers-certifications">
                    <tr>
                      <td className="text-center" style={{padding: '8px 4px'}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisAeronaves.Base}</td>
                      <td className="text-center" style={{padding: '8px 4px'}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaTotaisAeronaves.Aircraft}</td>
                      {Object.keys(self.props.schedule_days).map(function(k) {
                        var day = self.props.schedule_days[k];
                        return(
                          <td className="text-center" style={{padding: '8px 4px'}}>{day.weekday}</td>
                        );
                      })}
                    </tr>
                    <tr>
                    <td className="text-center" style={{padding: '8px 4px'}}></td>
                      <td className="text-center" style={{padding: '8px 4px'}}></td>
                      {Object.keys(self.props.schedule_days).map(function(k) {
                        var day = self.props.schedule_days[k];
                        return(
                          <td className="text-center" style={{padding: '8px 4px'}}>{day.day_simple}</td>
                        );
                      })}
                    </tr>
                    {Object.keys(self.state.grade_alternate['totals']).map(function(k) {
                      let line = self.state.grade_alternate['totals'][k];
                      return(
                        <tr>
                          <td className="text-center" style={{padding: '8px 4px'}}>{line.base}</td>
                          <td className="text-center" style={{padding: '8px 4px'}}>{line.aircraft}</td>
                          {Object.keys(self.props.schedule_days).map(function(k) {
                            var day = self.props.schedule_days[k];
                            let color = 'white';
                            if(line['needed'] !== null && typeof line['needed'] !== 'undefined' && typeof line.days[day.day] !== 'undefined') {
                              if(parseInt(line['needed']['cms']) < parseInt(line.days[day.day]['cms'])) { color = 'more_cms'; }
                              if(parseInt(line['needed']['cms']) > parseInt(line.days[day.day]['cms'])) { color = 'less_cms'; }
                              if(parseInt(line['needed']['copil']) < parseInt(line.days[day.day]['copil'])) { color = 'more_copil'; }
                              if(parseInt(line['needed']['copil']) > parseInt(line.days[day.day]['copil'])) { color = 'less_copil'; }
                              if(parseInt(line['needed']['cmdt']) < parseInt(line.days[day.day]['cmdt'])) { color = 'more_cmdt'; }
                              if(parseInt(line['needed']['cmdt']) > parseInt(line.days[day.day]['cmdt'])) { color = 'less_cmdt'; }
                              return(
                                <td className="text-center" style={self.state.total_colors[color]}><strong>{line.days[day.day].total}</strong></td>
                              );
                            } else {
                              return(
                                <td className="text-center" style={self.state.total_colors['white']}>SC</td>
                              );
                            }
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
        : ''}
    </div>
  }
</div>
    );
  }
}

export default ScheduleGradeEditTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeEditTab.js